import React from 'react';
import * as ReactDOM from "react-dom";
import './css/index.css';
import App from './App';
import { ThemeProvider } from '@ice/components';

ReactDOM.render(<ThemeProvider name={"light"}><App/></ThemeProvider>, document.getElementById('root'));
